import { toast } from 'react-toastify'
import validator from 'validator';

export default {
  ValidateForm(form){
    if(!form.name){
      toast.warning("Name is empty!")
      return false

    } else if(!form.contact_person) {
      toast.warning("Contact person is empty!")
      return false

    } else if(!form.address1) {
      toast.warning("Address1 is empty!")
      return false

    } else if(!form.address2) {
      toast.warning("Address2 is empty!")
      return false

    } else if(!form.postal) {
      toast.warning("Postal code is empty!")
      return false

    } else if(!form.city){
      toast.warning("City is empty!")
      return false

    } else if(!form.phone) {
      toast.warning("Phone number is empty!")
      return false

    } else if(!form.email) {
      toast.warning("Email address is empty!")
      return false

    } else if(!validator.isEmail(form.email)) {
      toast.warning("Email address is Invalid!")
      return false
    }

    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/master/contractor/helper/form.js